import PropTypes from 'prop-types';
import styled from 'styled-components';
import { TooltipMixin } from '../../mixins/components/TooltipMixin';
import CustomPropTypes from '../../util/custom-prop-types';
import { Popover } from '../Popover/Popover';

/**
 * @extends Popover
 * @subcomponents ['TooltipPopper']
 * @since 7.0.0
 */
var Tooltip = /*#__PURE__*/styled(Popover).withConfig({
  displayName: "Tooltip",
  componentId: "c11n-8-107-0__sc-11y2kok-0"
})(["", ""], TooltipMixin);
Tooltip.displayName = 'Tooltip';
Tooltip.propTypes = {
  /**
   * @deprecated Use `renderCloseButton` prop.
   */
  closeButton: PropTypes.node,
  /**
   * The Dialog `renderCloseButton` prop.
   */
  renderCloseButton: PropTypes.node,
  /**
   * @ignore
   */
  mediaQuery: CustomPropTypes.mediaQuery,
  /**
   * A contextual popup that displays a description for an element.
   */
  role: PropTypes.string,
  /**
   * The Dialog `shouldCloseOnESCKeyPress` prop.
   */
  shouldCloseOnESCKeyPress: PropTypes.bool,
  /**
   * The Dialog `shouldCloseOnOutsideClick` prop.
   */
  shouldCloseOnOutsideClick: PropTypes.bool,
  /**
   * The Dialog `shouldTakeFocus` prop.
   */
  shouldTakeFocus: PropTypes.bool,
  /**
   * The Dialog `shouldTrapFocus` prop.
   */
  shouldTrapFocus: PropTypes.bool,
  /**
   * The Dialog `shouldReturnFocus` prop.
   */
  shouldReturnFocus: PropTypes.bool
};
Tooltip.defaultProps = {
  closeButton: null,
  renderCloseButton: null,
  mediaQuery: {},
  modal: false,
  shouldCloseOnESCKeyPress: true,
  shouldCloseOnOutsideClick: false,
  shouldTakeFocus: false,
  shouldTrapFocus: false,
  shouldReturnFocus: false,
  role: 'tooltip'
};

/** @component */
export { Tooltip };